import React, { useEffect } from 'react';
import { Grid, Modal, Button, activateTheme, themes } from '../../../../canvasComponents/index';
import { FormattedMessage, IntlProvider } from 'react-intl';
// messages
import messages from '../messages';
import '../../../../css/components/PopUps/PopUps.scss';

export function FileUploadModal({
  showModal,
  setShowModal,
  maxFilesModalErrorMessage,
  localParams,
}) {
  useEffect(() => {
    activateTheme(themes.sonnet);
  }, []);
  return showModal.isOpen ? (
    <IntlProvider locale={localParams?.lang} messages={localParams?.i18n}>
      <Modal
        id="fileupload_modal"
        isOpen={showModal}
        onRequestClose={() => {
          setShowModal(false);
        }}
      >
        <Grid>
          <Grid.Row mt4>
            <span className="pop-up-title"><FormattedMessage {...messages.someUploads} /></span>
          </Grid.Row>
          <Grid.Row mt4 mb4>
            <span className="pop-up-text-bigger"><FormattedMessage id={maxFilesModalErrorMessage} defaultMessage={maxFilesModalErrorMessage} /></span>
          </Grid.Row>
          <Grid.Row mt4>
            <span className="pop-up-text-bigger bold"><FormattedMessage {...messages.filesNotUploaded} /></span>
          </Grid.Row>
          <Grid.Row>
            {showModal.removedFiles && showModal.removedFiles.map((removedFile) => <span key={`removed-file-${Math.random() * 0xffffffffffff}`} className="pop-up-text-bigger">{removedFile.name}</span>)}
          </Grid.Row>
          <Grid.Row mt4 mb4>
            <span className="pop-up-text-bigger"><FormattedMessage {...messages.dontWorry} /></span>
          </Grid.Row>
          <Grid.Row>
            <span className="center">
              <Button
                className="black-button"
                onClick={() => {
                  setShowModal((prevState) => ({
                    ...prevState,
                    isOpen: false,
                  }));
                }}
              >
                <FormattedMessage {...messages.okay} />
              </Button>
            </span>
          </Grid.Row>
        </Grid>
      </Modal>
    </IntlProvider>
  ) : null;
}
